module.exports = __webpack_public_path__ + "img/book-open.ae7c0111.png";